import React from "react";
import {
  TextInput,
  TextInputProps as LibTextInputProps,
} from "@literati/public-ui-shared-react";
import DLSErrorMessage from "components/DLS/DLSErrorMessage";
import { FormikChildrenRenderProps } from "components/Step/StepLayout";
import { AuthValues } from "components/authenticate/authTypes";

export const textInputEmailDefaultProps = {
  label: "Email Address",
  name: "email",
  placeholder: "Enter your email address",
  type: "email",
};

export const textInputLoginDefaultProps = {
  label: "Email Address*",
  name: "login",
  placeholder: "Enter your email address",
  type: "email",
};

export const textInputPasswordDefaultProps = {
  label: "Password*",
  name: "password",
  placeholder: "Enter your password",
  type: "password",
};

export type DefaultProps =
  | typeof textInputEmailDefaultProps
  | typeof textInputLoginDefaultProps
  | typeof textInputPasswordDefaultProps;

const DEFAULT_PROPS: Record<Variant, DefaultProps> = {
  email: textInputEmailDefaultProps,
  login: textInputLoginDefaultProps,
  password: textInputPasswordDefaultProps,
};

export type AuthErrorRenderProps = Pick<
  FormikChildrenRenderProps<AuthValues>,
  "errors" | "submitCount"
>;
export type TextInputProps = Omit<
  LibTextInputProps,
  "label" | "name" | "placeholder" | "type"
>;

export type Variant = "email" | "login" | "password";

export interface AuthFormTextInputProps
  extends TextInputProps,
    AuthErrorRenderProps {
  hasBlurred: boolean;
  variant: Variant;
}

export const AuthFormTextInput = ({
  errors,
  hasBlurred,
  submitCount,
  variant,
  ...textInputProps
}: AuthFormTextInputProps) => {
  const textInputDefaultProps = DEFAULT_PROPS[variant];

  return (
    <>
      <TextInput {...textInputDefaultProps} {...textInputProps} />
      {(submitCount > 0 || hasBlurred) && errors[variant] ? (
        <DLSErrorMessage css="padding-left: 0" message={errors[variant]} />
      ) : null}
    </>
  );
};

export default AuthFormTextInput;
